const TURN_USERNAME = process.env.REACT_APP_TURN_USERNAME ?? '';
const TURN_CREDENTIAL = process.env.REACT_APP_TURN_CREDENTIAL ?? '';

export const iceServers: RTCIceServer[] = [
  {
    username: TURN_USERNAME,
    credential: TURN_CREDENTIAL,
    urls: 'turn:global.relay.metered.ca:443',
  },
  {
    username: TURN_USERNAME,
    credential: TURN_CREDENTIAL,
    urls: 'turn:global.relay.metered.ca:80',
  },
  {
    username: TURN_USERNAME,
    credential: TURN_CREDENTIAL,
    urls: 'turn:global.relay.metered.ca:80?transport=tcp',
  },
  {
    username: TURN_USERNAME,
    credential: TURN_CREDENTIAL,
    urls: 'turns:global.relay.metered.ca:443?transport=tcp',
  },
  { urls: 'stun:stun.relay.metered.ca:80' },
  { urls: 'stun:stun.l.google.com:19302' },
  { urls: 'stun:stun.services.mozilla.com' },
];
